import Step from './Step'
import StepperWrap from './Stepper'

const Stepper = { Step: Step, Wrap: StepperWrap }

export default Stepper
